import http from "./http-common";
import qs from "qs";
import { startOfDay, endOfDay } from "../functions/dateRange";
import NewsModel from "../models/news";

// eslint-disable-next-line
export default new (class NewsService {
  // Get all
  async getNews({
    keyword,
    startDate,
    endDate,
    sort = "desc",
    page = 1,
    pageSize = 5,
  }) {
    const query = qs.stringify(
      {
        sort: [`publishedAt:${sort}`],
        filters: {
          $or: [
            {
              title: {
                detail_TH: {
                  $contains: keyword,
                },
              },
            },
            {
              title: {
                detail_EN: {
                  $contains: keyword,
                },
              },
            },
          ],
          $and: [
            {
              // รวมวันสุดท้ายทั้งวัน (เดิม $lt เที่ยงคืนของวันสุดท้าย = ตัดวันนั้นทิ้ง)
              publishedAt: {
                $lte: endOfDay(endDate),
                $gte: startOfDay(startDate),
              },
            },
          ],
        },
        pLevel: 5,
        pagination: {
          page: page,
          pageSize: pageSize,
        },
      },
      {
        encodeValuesOnly: true,
      }
    );
    return await http
      .get("/news?" + query)
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((news) => NewsModel.get(news))
        );

        const meta = response.data.meta;

        return [data, meta];
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async getMainpageNews({ sort = "desc", page = 1, pageSize = 3 }) {
    const query = qs.stringify(
      {
        sort: [`publishedAt:${sort}`],
        pLevel: 5,
        pagination: {
          page: page,
          pageSize: pageSize,
        },
      },
      {
        encodeValuesOnly: true,
      }
    );
    return await http
      .get("/news?" + query)
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((news) => NewsModel.get(news))
        );

        return [data];
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // Get by name
  async getNewsBySlug(slug, status = 'published') {
    return await http
      // ให้ Strapi กรองด้วย slug — ดึงมาทั้งหมดแล้วค่อยหาจะได้แค่ 25 รายการแรก
      .get(`/news?pLevel&status=${status}&filters[Slug][$eq]=${encodeURIComponent(slug)}`)
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((news) => NewsModel.get(news))
        );

        return data[0];
      })
      .catch((error) => {
        console.log(error);
      });
  }

  async getNewsByTag({ sort = "desc", tag = "" }) {
    const query = qs.stringify(
      {
        filters: {
          $and: [
            {
              tag: {
                tag: {
                  $eq: tag,
                },
              },
            },
          ],
        },
        sort: [`publishedAt:${sort}`],
        pLevel: 5,
      },
      {
        encodeValuesOnly: true,
      }
    );
    return await http
      .get("/news?" + query)
      .then(async (response) => {
        const data = await Promise.all(
          response.data.data.map((news) => NewsModel.get(news))
        );

        return [data];
      })
      .catch((error) => {
        console.log(error);
      });
  }
})();
